/**
 * IconText component renders a text with an optional icon.
 *
 * @param {boolean} icon - Determines which icon to display.
 * @param {string} text - The text to display alongside the icon.
 * @param {string} classes - Additional CSS classes for styling the component.
 * @example
 * return (
 *  <IconText icon='location text='You are here' classes='text-gray-500' />
 * )
 */
import React from "react";

import {
  IoLocationOutline,
  IoClipboardOutline,
  IoTimeOutline,
} from "react-icons/io5";

const IconText = ({
  icon,
  text,
  truncate = false,
  classes,
}) => {
  let IconComponent;
  switch (icon) {
    case "location":
      IconComponent = <IoLocationOutline size={12} />;
      break;
    case "clipboard":
      IconComponent = <IoClipboardOutline size={12} />;
      break;
    case "time":
      IconComponent = <IoTimeOutline size={12} />;
      break;
    default:
      IconComponent = null;
  }
  return (
    <div
      className={`flex flex-row items-center ${classes} pr-2`}
    >
      <div className="max-sm:hidden rounded-3xl p-1 shadow-sm">{IconComponent}</div>
      <div className={`text-sm pr-2 rounded-md ${truncate ? "truncate" : ""}`}>
        <p className={`${truncate ? "truncate" : ""}  max-sm:ml-1 `}>{text}</p>
      </div>
    </div>
  );
};

export default IconText;
